/* 
Object:         WebServiceCredentials
Description:    Logic and events for the module WebServiceCredentials
Used in:        WebServiceCredentials
*/

import { ModuleActionViewEnum }         from "../enums/moduleActionViewEnum";
import { webService_ObjectTypeEnum }    from "../enums/webService_ObjectTypeEnum";

import * as appsettings     from "../appsettings";
import * as dialog          from "../dialog";
import * as form            from "../form";
import * as listbox         from "../listbox";
import * as main            from "../main";
import * as moment          from "moment";
import * as navigation      from "../navigation";
import * as timeinterval    from "../timeinterval";
import * as viewmode        from "../viewmode";
import * as grid            from "../grid";

let _msg_notsaved = "";
let LABEL_ETooManyDays = "";

function showHideWebService(objectType: webService_ObjectTypeEnum): void {

    //main.setHideDivBootstrap("TRUserName", false);
    //main.setHideDivBootstrap("TRPassword", false);
    main.setHideDivBootstrap("TRTimezone", false);
    //main.setHideDivBootstrap("TRCommPeriod", false);
    //main.setHideDivBootstrap("TRCommFrom", false);
    //main.setHideDivBootstrap("TRRetryInterval", false);
    //main.setHideDivBootstrap("TRMaxRetries", false);
    main.setHideDivBootstrap("TRMoveFile", false);
    main.setHideDivBootstrap("TRRegio", false);
    main.setHideDivBootstrap("TRGroupOrNodeName", false);
    main.setHideDivBootstrap("TRCustomOccupancyText", false);
    main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", false);
    main.setHideDivBootstrap("TRGMS", false);
    main.setHideDivBootstrap("TRInhoudText", false);

    switch (objectType) {
        case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V5:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V6:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V7:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_VerbindingStatusRequest_V8:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V5:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V6:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V7:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_IncidentSynchronisatieRequest_V8:
            main.setHideDivBootstrap("TRGMS", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V5:
            main.setHideDivBootstrap("TRCustomOccupancyText", true);
            main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
            main.setHideDivBootstrap("TRInhoudText", true);
            main.setHideDivBootstrap("TRThemas", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V6:
            main.setHideDivBootstrap("TRCustomOccupancyText", true);
            main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
            main.setHideDivBootstrap("TRInhoudText", true);
            main.setHideDivBootstrap("TRThemas", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V7:
            main.setHideDivBootstrap("TRCustomOccupancyText", true);
            main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
            main.setHideDivBootstrap("TRInhoudText", true);
            main.setHideDivBootstrap("TRThemas", true);
            break;
        case webService_ObjectTypeEnum.Outgoing_GMS_Incident_aansluiting_V8:
            main.setHideDivBootstrap("TRCustomOccupancyText", true);
            main.setHideDivBootstrap("TRNoOccupancyEnoughMsg", true);
            main.setHideDivBootstrap("TRInhoudText", true);
            main.setHideDivBootstrap("TRThemas", true);
            break;
        case webService_ObjectTypeEnum.Incomming_GMS_Incident_aansluiting: // 7                
            main.setHideDivBootstrap("TRRegio", true);
            main.setHideDivBootstrap("TRGroupOrNodeName", true);
            break;
    }
}

function showHideCommMethod(commMethod: string): void {
    if (commMethod == 'Interval') {
        main.setHideDivBootstrap("TRCommPeriod", true);
        main.setHideDivBootstrap("TRCommFrom", false);
        main.setHideDivBootstrap("TRRetryInterval", false);
        main.setHideDivBootstrap("TRMaxRetries", false);
    } else {
        main.setHideDivBootstrap("TRCommPeriod", false);
        main.setHideDivBootstrap("TRCommFrom", true);
        main.setHideDivBootstrap("TRRetryInterval", true);
        main.setHideDivBootstrap("TRMaxRetries", true);
    }
}

/**
 * Delete item from grid
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this as kendo.ui.Grid;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {

        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as WebServiceCredential;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("WebServiceCredentials/Delete?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID),
            success: function (): void {
                // Refresh datasource grid 
                $("#WebServiceCredentialsGrid").data("kendoGrid").dataSource.read();
            }
        });
    }

    function callingCallback(): void {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * Update a item from grid
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    var dataItem = this.dataItem($(e.currentTarget).closest("tr")) as WebServiceCredential;

    // Label
    var label = dataItem.Label;

    // Edit mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("WebServiceCredentials/Edit?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
}


/**
 * Show item from grid
 */
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem 
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as WebServiceCredential;

    // Label
    const label = dataItem.Label;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("WebServiceCredentials/Show?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
}

export function loggingItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem 
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as WebServiceCredential;

    // Label
    const label = dataItem.Label;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("WebServiceCredentials/Log?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
}

export function usersItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // Get DateItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as WebServiceCredential;

    // Label
    const label = dataItem.Label;

    // Show mode Form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("WebServiceCredentials/Users?webServiceCredentialsId=" + dataItem.WebServiceCredentialsID + "&breadcrumbLabel=" + label);
}

export function formInitialize(): void {

    const dataItem = $("#WebServiceID").data("kendoDropDownList").dataItem() as SelectListItemExtended;
    const objectType = dataItem.ParentValue;
    showHideWebService(parseInt(objectType));

    const commMethod = $('#CommMethod').val().toString();
    showHideCommMethod(commMethod);
}

export function webServiceChanged(e: kendo.ui.DropDownListChangeEvent): void {
    const dataItem = e.sender.dataItem() as SelectListItemExtended;
    showHideWebService(parseInt(dataItem.ParentValue));
}

export function commMethodChanged(e: kendo.ui.DropDownListChangeEvent): void {
    const dataItem = e.sender.dataItem() as SelectListItem;
    showHideCommMethod(dataItem.Value);
}

export function callIncidentBrokerClicked(formId: string, webServiceCredentialsId: number, method: string): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("WebServiceCredentials/CallIncidentBrokerService"),
        data: { webServiceCredentialsId: webServiceCredentialsId, method: method },
        success: function (responseData) {
            if (responseData != undefined) {
                form.showServerResponse(formId, responseData, function () { });
            }
        }
    });
}

export function visibilityItem(dataItem: WebServiceCredentialRow): boolean {

    const objectType = Number(dataItem.WebService_ObjectType);

    return (objectType === webService_ObjectTypeEnum.Import_AG5 ||
            objectType === webService_ObjectTypeEnum.Import_AED_Alert);
}

export function logInitialize(ETooManyDays: string): void {
    LABEL_ETooManyDays = ETooManyDays;

    main.setHideDivBootstrap("periodSelector", false);
    grid.loadGridOptions("WebServiceCredentialsLogGrid");
    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("DivLblTooMany", false);

    const grid = $("#WebServiceCredentialsLogGrid").data("kendoGrid");
    if (grid != null && grid != undefined) {
        grid.pager.dataSource.page(1);
        grid.dataSource.read();
    }
}

export function getAdditionalData(webServiceCredentialsId: number): { webServiceCredentialsId: number, timestampFrom: Date, timestampTo: Date } {

    // defaults
    const beginDateTime = moment();
    let toLocal = new Date(beginDateTime.unix() * 1000);
    let fromLocal = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);

    // timeinterval
    const ddl = $("#TimeInterval").data("kendoDropDownList");
    if (ddl != null && ddl != undefined) {
        const ddlval = parseInt(ddl.value());
        fromLocal = timeinterval.getBeginPeriodSelection(ddlval, null);
        toLocal = timeinterval.getEndPeriodSelection(ddlval, null);

        const tsDays = (toLocal.getTime() - fromLocal.getTime()) / (1000 * 3600 * 24);
        if (tsDays >= 33) {

            // make a message
            main.setHideDiv("DivLblTooMany", true);

            const lblEmsg = $("#LblTooMany");
            if (lblEmsg != null && lblEmsg != undefined) {
                lblEmsg.text(LABEL_ETooManyDays);
            }

            fromLocal = toLocal = new Date(Date.now());
        }
    }

    return {
        webServiceCredentialsId: webServiceCredentialsId,
        timestampFrom: fromLocal,
        timestampTo: toLocal
    };
}

/**
* Init Users
* @param {string} notsaved
*/
export function users_initialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Users - LDataNotSaved (label)
*/
export function users_Get_LDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}


/**
* Users - Enable save button
*/
export function users_enableSaveButton(): void {
    const btnSave = document.getElementById("saveButtonUsers");
    btnSave.removeAttribute("disabled");
}

/**
* Users - Disable save button
*/
export function users_disableSaveButton(): void {
    const btnSave = document.getElementById("saveButtonUsers");
    btnSave.setAttribute("disabled", "disabled");
}

/**
* Users - Left clicked
*/
export function users_leftClicked(): void {
    users_enableSaveButton();
    listbox.moveItems("WebServiceCredentials_Users_CplSelected", "WebServiceCredentials_Users_CplNotSelected", "#Users_Validation", users_Get_LDataChangedNotSavedYet());
}

/**
* Users - Right clicked
*/
export function users_rightClicked(): void {
    users_enableSaveButton();
    listbox.moveItems("WebServiceCredentials_Users_CplNotSelected", "WebServiceCredentials_Users_CplSelected", "#Users_Validation", users_Get_LDataChangedNotSavedYet());
}


/**
* Users - Save button clicked
* @param {string} actionUrl
* @param {number} webServiceCredentialsId
*/
export function users_saveButtonClicked(actionUrl: string, webServiceCredentialsId: number): void {

    users_disableSaveButton();

    const json = $("#WebServiceCredentials_Users_CplSelected").data("kendoListBox").dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list), webServiceCredentialsId: webServiceCredentialsId },
        success: function (responseData: responseModel | undefined | null) {

            $('#Users_Validation').text("");

            if (responseData.Succesfully) {
                if (responseData.CallbackJS != null && responseData.CallbackJS != undefined) {
                    Function(responseData.CallbackJS)(); // execute callbackJS content (dont wrap more than one function call in one function as a wrapper, that will not execute)
                }
            } else {
                $('#WebServiceCredentials_Users_CplNotSelected').data("kendoListBox").dataSource.read();
                $('#WebServiceCredentials_Users_CplSelected').data("kendoListBox").dataSource.read();
            }

            const color = (responseData.Succesfully ? 'green' : 'red');
            $('#Users_Validation').text(responseData.Message);
            $('#Users_Validation').attr('style', 'color:' + color);
        }
    });
}
